<div class="row">
    <div class="col-md-12">
        <div class="row modal_header">
            <div class="col-9">
                <span class="ml-2">{{head}}</span>
            </div>
            <div class="col-3 text-right">
                <a style="cursor: pointer">
                    <i
                        class="fa-solid fa-xmark"
                        (click)="Close()"
                        style="font-size: xx-large"
                    ></i>
                </a>
            </div>
        </div>
        <div class="card card_content"  style="padding: 5px !important;">
            <form [formGroup]="vapproveform">
            <div class="row mt-3 d-flex justify-content-center">
                            
                <div class="col-xl-6 mt-4" *ngIf="displayType != 'ismanual' && displayType != 'reject' && !nodata" >
                    <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                        <mat-label>Service Change effective date</mat-label>
                        <input readonly matInput  [matDatepicker]="startDatePicker"
                            formControlName="effectivedate" autocomplete="off" [min]="nextDate"
                            placeholder="Select From Date" class="custom-input-border" 
                            (click)="startDatePicker.open()">
                        <mat-datepicker-toggle matSuffix [for]="startDatePicker" style="color:black;">
                            <button mat-icon-button>
                                <mat-icon>event</mat-icon>
                            </button>
                        </mat-datepicker-toggle>
                        <mat-datepicker #startDatePicker></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-xl-11 mt-4" *ngIf="displayType != 'ismanual' && displayType != 'reject' && nodata" >
                    <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                        <mat-label>Service Change effective date</mat-label>
                        <input readonly matInput  [matDatepicker]="startDatePicker"
                            formControlName="effectivedate" autocomplete="off" [min]="nextDate"
                            placeholder="Select From Date" class="custom-input-border" 
                            (click)="startDatePicker.open()">
                        <mat-datepicker-toggle matSuffix [for]="startDatePicker" style="color:black;">
                            <button mat-icon-button>
                                <mat-icon>event</mat-icon>
                            </button>
                        </mat-datepicker-toggle>
                        <mat-datepicker #startDatePicker></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-xl-11 mt-4" *ngIf="displayType == 'ismanual'" >
                    <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                        <mat-label>Service Change effective date</mat-label>
                        <input readonly matInput  [matDatepicker]="startDatePicker"
                            formControlName="effectivedate" autocomplete="off" [min]="nextDate"
                            placeholder="Select From Date" class="custom-input-border" 
                            (click)="startDatePicker.open()">
                        <mat-datepicker-toggle matSuffix [for]="startDatePicker" style="color:black;">
                            <button mat-icon-button>
                                <mat-icon>event</mat-icon>
                            </button>
                        </mat-datepicker-toggle>
                        <mat-datepicker #startDatePicker></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-sm-12 col-xl-11 mt-4" *ngIf="displayType === 'reject'">

                    <mat-form-field appearance="fill" hideRequiredMarker
                    [ngClass]="'textArea-mat-field'" style="border-radius: 0 !important;">
                    <mat-label>Reason</mat-label>
                    <textarea rows="4" matInput type="text" placeholder="Enter Query"
                        formControlName="reason" autocomplete="off" specialIsAlphaNumeric
                        class="col-12"></textarea>
                </mat-form-field>
                  </div>
                <div class="col-sm-12 col-md-6 mt-4" *ngIf="displayType === 'vapprove'">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>vumatelNetworkIdentifier</mat-label>
                        <input matInput  maxlength="25" formControlName="vumatelNetworkIdentifier" 
                             class="col-10" autocomplete="off">
                    </mat-form-field>
                </div>
                <div class="col-sm-12 col-md-6 mt-4" *ngIf="(displayType === 'approve'||displayType === 'bapprove') && !nodata ">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>Line Number/FSAN</mat-label>
                        <input matInput  maxlength="25" formControlName="fsan" 
                             class="col-10" autocomplete="off">
                    </mat-form-field>
                </div>
                </div>


                <div class="row" *ngIf="displayType==='bapprove'">
                    <div class="col-xl-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Complex / Estate</mat-label>
                            <mat-select class="scrollbarcs" formControlName="balwinComplexType" 
                            (filteredReturn)="filteredList= $event"
                                placeholder="Select Complex / Estate ">
                                <mat-select-filter [displayMember]="'value'" [array]="complexlist"
                               ></mat-select-filter>
                                <mat-option *ngFor="let item of filteredList" [value]="item.key"
                                    style="overflow-y: scroll !important;">
                                  {{item.value}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                                   <div class="col-sm-12 col-md-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Complex Unit No</mat-label>
                            <input matInput  maxlength="25" formControlName="complexUnitNo" 
                                 class="col-10" autocomplete="off">
                        </mat-form-field>
                    </div>
                </div>
                <div class="d-flex justify-content-end button-style mt-3 mr-2">
                    <button class="btn btn-primary my-2 mr-3" type="submit" (click)="Close()"
                    matButton>No</button>
                    <button class="btn btn-secondary my-2 " type="submit" (click)="onsubmit()"
                        matButton>Yes</button>
                       
                </div>
                </form>
        </div>

    </div>
</div>
